import { Box, Tooltip } from '@mui/material'
import { Organization } from '@/types/organizations'
import LabeledData from '@/components/labeled-data/LabeledData'
import OrganizationPickerWithDialog from './OrganizationPickerWithDialog'
import OrganizationWithParent from './OrganizationWithParent'
import useOrganizationTypeName from './useOrganizationTypeName'

type OrganizationAssignmentSelectProps = {
  isFetching: boolean
  selectedOrganization: Organization
  organizations: Organization[]
  onChange: (organization: Organization) => void
  rootTreeOrgId: string
  dense?: boolean
  disabled?: boolean
  showParentOrg?: boolean
  variant?: 'standard' | 'outlined'
}

export default function OrganizationAssignmentSelect({
  isFetching,
  selectedOrganization,
  organizations,
  onChange,
  dense,
  disabled,
  showParentOrg = false,
  rootTreeOrgId,
  variant = 'standard',
}: OrganizationAssignmentSelectProps) {
  const canEdit = !disabled

  const organizationTypeName = useOrganizationTypeName({
    organization: selectedOrganization,
  })

  return (
    <>
      {canEdit ? (
        <OrganizationPickerWithDialog
          currentOrganization={selectedOrganization}
          dense={dense}
          isFetching={isFetching}
          organizations={organizations}
          rootTreeOrgId={rootTreeOrgId}
          showParentOrg={showParentOrg}
          title="Assign to Organization"
          onSave={onChange}
          variant={variant}
        />
      ) : (
        <Tooltip
          arrow
          enterDelay={1000}
          title="Read-Only Access"
          disableInteractive
        >
          <Box
            sx={{
              px: 1,
              pb: 0.5,
              pt: 1,
              borderRadius: 2,
            }}
          >
            {showParentOrg ? (
              <OrganizationWithParent
                organization={selectedOrganization}
                organizations={organizations}
                dense={dense}
              />
            ) : (
              <LabeledData
                label={organizationTypeName}
                data={selectedOrganization.name}
                dense={dense}
              />
            )}
          </Box>
        </Tooltip>
      )}
    </>
  )
}
